import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import SmsReportCard from "../../components/report/SmsReportCard";

const SmsReport = ({ token, admin }) => {

	const history = useHistory();

	const [toggled, setToggled] = useState(false);

	useEffect(() => {
		if (!admin || !admin.sms_report) {
			history.push('/admin/dashboard');
		}
	}, []);

	const handleToggle = () => {
		setToggled(!toggled);
	};

	return (
		<div className="admin-page-container">
			<Sidebar toggled={toggled} setToggled={handleToggle} />
			<div className="admin-page">
				<Topbar handleToggle={handleToggle} />
				<div className="admin-content">
					<SmsReportCard
						role="operator"
						token={token}
						sms_credit={admin?.smsCredit}
					/>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = state => {
	return {
		admin: state.admin.admin,
		token: state.admin.token
	};
};

export default connect(mapStateToProps, null)(SmsReport);